import styled from 'styled-components';
import { PaginationDots as DotsBase } from '@sberdevices/plasma-core';

/**
 * Оборачивающий компонент для пагинации точками.
 * Стилизованный компонент, обладающий всеми свойствами ``div``.
 */
export const PaginationDots = styled(DotsBase)``;
